import _ from 'lodash'

export const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike', 'link'], // toggled buttons
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [
    { header: [1, 2, 3, 4, 5, 6, false] },
    {
      align: [],
    },
  ],

  ['clean'], // remove formatting button
]

export const getConfig = (options) => {
  if (_.isEmpty(options)) {
    return toolbarOptions
  }
  if (options.image) {
    const config = _.cloneDeep(toolbarOptions)
    _.last(config).push('image')
    return config
  }
}

export default toolbarOptions
